import { ModelMixin } from '../core/base-generic.model';

/**
 * Used to fetch inquiry fields from Persona for a given inquiry ID
 * This is primarily used for pre-filling re-verification inquiries
 */
export class PersonaInquiryFields extends ModelMixin<PersonaInquiryFields>() {
    //The inquiry fields data returned from the API
    get data(): Record<string, any> {
        return this._rawAttributes?.data || {};
    }

    protected static _resource = 'commonComponents/fetchPersonaInquiryFields/:inquiry_id' as const;
    protected static _version = 'v2';
}
